import React from 'react';
import { shape, string } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  box: {
    backgroundColor: theme.palette.neutral.lighter,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 5,
    height: 100,
    marginTop: 5,
    marginLeft: 5,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      height: 80,
    },
  },
  icon: {
    color: theme.palette.primary.main,
    display: 'block',
    lineHeight: '120%',
  },
  text: {
    color: theme.palette.neutral.medium,
    weight: 400,
    lineHeight: '20px',
  },
}));

const AlertMessageBox = ({ message, Icon }) => {
  const classes = useStyles();

  return (
    <Box classes={{ root: classes.box }}>
      <Box pl={{ xs: 2, md: 1 }} display="flex" alignItems="center">
        <Icon testid="icon" className={classes.icon} />
      </Box>
      <Box px={{ xs: 2, md: 1 }} display="flex" alignItems="center">
        <Typography testid="message" variant="body2" classes={{ root: classes.text }}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

AlertMessageBox.propTypes = {
  message: string.isRequired,
  Icon: shape({}).isRequired,
};

export default AlertMessageBox;
